import React, {Component} from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { toast } from 'react-toastify';
import moment from 'moment';
import { ColorRing } from 'react-loader-spinner';
import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {
  Button, Row, Col, FormInput, FormTextarea,
  Modal, ModalBody, ModalHeader, Badge
} from "shards-react";
import './blog.scss';

const thStyle = {padding: '10px 12px', background: '#F8FAFC', color: '#475569', fontWeight: 600, textAlign: 'left', borderBottom: '1px solid #E5E7EB', whiteSpace: 'nowrap'};
const tdStyle = {padding: '10px 12px', borderBottom: '1px solid #F1F5F9', verticalAlign: 'middle'};
const mLabel = {fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6, display: 'block'};
const segStyle = (active) => ({
  padding: '8px 18px', borderRadius: 8, cursor: 'pointer', fontSize: 13,
  border: active ? '1px solid #4A6CF7' : '1px solid #E5E7EB',
  background: active ? '#EEF2FF' : '#fff',
  color: active ? '#4A6CF7' : '#6B7280',
  fontWeight: active ? 700 : 500
});

@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me: teamUser.me }))
@inject(({ blog }) => ({ getBlogList: blog.getBlogList, updateBlog: blog.updateBlog, removeBlog: blog.removeBlog }))
@observer
class BlogList extends Component {

  @observable isLoading = true;
  @observable teamUser = {};
  @observable store = {};

  @observable list = {};
  @observable listParams = { page: 1, limit: 10 };

  @observable isModalOpen = false;
  @observable editMode = 'create';
  @observable form = this.emptyForm();

  quillModules = {
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['blockquote', 'link', 'image'],
      ['clean']
    ],
    clipboard: { matchVisual: false }
  };
  quillFormats = ['header','bold','italic','underline','strike','color','background','align','list','bullet','blockquote','link','image'];

  emptyForm() {
    return { _id: null, title: '', slug: '', author: '', metaDescription: '', tags: '', content: '', summary: '', thumbnail: '', isDisplay: true };
  }

  // 제목 -> URL 슬러그 (한글/영문/숫자 허용, 공백은 하이픈)
  slugify = (str) => {
    return (str || '').toString().trim().toLowerCase()
      .replace(/[^a-z0-9가-힣\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  componentDidMount() {
    this.init();
  }

  @action init = async () => {
    if (this.props.isLogin) {
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};
      await this.loadList();
      this.isLoading = false;
    }
  };

  @action loadList = async (page) => {
    if (page) this.listParams.page = page;
    const res = await this.props.getBlogList({
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo || 1,
      page: this.listParams.page,
      limit: this.listParams.limit
    });
    this.list = (res && res.docs) ? res : { docs: [], totalDocs: 0 };
  };

  @action openCreate = () => {
    this.form = this.emptyForm();
    this.editMode = 'create';
    this.isModalOpen = true;
  };

  @action openEdit = (item) => {
    this.form = {
      _id: item._id,
      title: item.title || '',
      slug: item.slug || '',
      author: item.author || '',
      metaDescription: item.metaDescription || '',
      tags: Array.isArray(item.tags) ? item.tags.join(', ') : (item.tags || ''),
      content: item.content || '',
      summary: item.summary || '',
      thumbnail: item.thumbnail || '',
      isDisplay: item.isDisplay !== false
    };
    this.editMode = 'edit';
    this.isModalOpen = true;
  };

  @action save = async () => {
    if (!this.form.title || !this.form.title.trim()) { toast.error('제목을 입력해주세요.'); return; }

    const data = {
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo || 1,
      title: this.form.title,
      slug: (this.form.slug || '').trim() || this.slugify(this.form.title),
      author: this.form.author,
      metaDescription: this.form.metaDescription,
      tags: (this.form.tags || '').split(',').map(t => t.trim()).filter(Boolean),
      content: this.form.content,
      summary: this.form.summary,
      thumbnail: this.form.thumbnail,
      isDisplay: !!this.form.isDisplay
    };
    if (this.editMode === 'edit' && this.form._id) data.id = this.form._id;

    const res = await this.props.updateBlog(data);
    if (res && res.data) {
      toast.success(this.editMode === 'create' ? '블로그 글이 작성되었습니다.' : '블로그 글이 수정되었습니다.');
      this.isModalOpen = false;
      await this.loadList();
    } else {
      toast.error('저장에 실패했습니다.');
    }
  };

  @action remove = async (item) => {
    if (!window.confirm('"' + (item.title || '') + '" 글을 삭제하시겠습니까?')) return;
    const res = await this.props.removeBlog({ id: item._id });
    if (res && res.data) {
      toast.success('삭제되었습니다.');
      await this.loadList();
    } else {
      toast.error('삭제에 실패했습니다.');
    }
  };

  renderPagination = () => {
    const list = this.list || {};
    if (!list.totalPages || list.totalPages <= 1) return null;
    const cur = list.page;
    const total = list.totalPages;
    const startNum = (parseInt((cur - 1) / 10) * 10) + 1;
    const endNum = startNum + 9 < total ? startNum + 9 : total;
    const items = [];
    for (let i = startNum; i <= endNum; i++) {
      items.push(<li key={i} className={i === cur ? 'on' : ''} onClick={() => this.loadList(i)}>{i}</li>);
    }
    return (
      <div className="bl-pagination">
        <ul>
          {cur !== 1 ? <li onClick={() => this.loadList(1)}><FeatherIcon icon="chevrons-left" size="14"/></li> : null}
          {startNum - 1 > 0 ? <li onClick={() => this.loadList(startNum - 1)}><FeatherIcon icon="chevron-left" size="14"/></li> : null}
          {items}
          {endNum !== total ? <li onClick={() => this.loadList(startNum + 10)}><FeatherIcon icon="chevron-right" size="14"/></li> : null}
          {cur !== total ? <li onClick={() => this.loadList(total)}><FeatherIcon icon="chevrons-right" size="14"/></li> : null}
        </ul>
      </div>
    );
  };

  render() {
    if (this.isLoading) {
      return (
        <div className="text-center" style={{paddingTop: '100px'}}>
          <ColorRing visible={true} height="60" width="60" colors={['#5a6169','#5a6169','#5a6169','#5a6169','#5a6169']}/>
        </div>
      );
    }
    const docs = (this.list && this.list.docs) || [];
    const total = (this.list && this.list.totalDocs) || 0;

    return (
      <div className="main-content blog-list-page">
        <PageTitle />
        <div className="widget-box">
          <div className="section-box">
            <div className="section-tit" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #F1F5F9'}}>
              <div>
                <h3 style={{margin: 0, fontSize: 15, fontWeight: 700, color: '#1F2937'}}>블로그 글</h3>
                <p style={{margin: '4px 0 0', fontSize: 13, color: '#6B7280'}}>총 {total.toLocaleString()}건</p>
              </div>
              <Button theme="primary" onClick={this.openCreate} style={{display: 'inline-flex', alignItems: 'center', gap: 4}}>
                <FeatherIcon icon="plus" size="16"/> 글 작성
              </Button>
            </div>
            <div style={{padding: '8px 20px 20px'}}>
              {docs.length === 0 ? (
                <div className="src-empty-state" style={{background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: 10, marginTop: 12, padding: '48px 20px', textAlign: 'center', color: '#9CA3AF'}}>
                  <FeatherIcon icon="file-text" size="40"/>
                  <div style={{marginTop: 12, fontSize: 15, fontWeight: 600, color: '#4B5563'}}>등록된 블로그 글이 없습니다</div>
                  <div style={{marginTop: 6, fontSize: 13}}>상단의 <b>글 작성</b> 버튼으로 첫 글을 작성해 보세요.</div>
                </div>
              ) : (
                <table className="bl-table" style={{width: '100%', borderCollapse: 'collapse', fontSize: 13, marginTop: 8}}>
                  <thead>
                  <tr>
                    <th style={thStyle}>제목</th>
                    <th style={{...thStyle, width: 90}}>노출</th>
                    <th style={{...thStyle, width: 130}}>작성일</th>
                    <th style={{...thStyle, width: 150}}>작업</th>
                  </tr>
                  </thead>
                  <tbody>
                  {docs.map((item, i) => (
                    <tr key={item._id || i}>
                      <td style={tdStyle}>
                        <span style={{fontWeight: 600, color: '#1F2937'}}>{item.title || '(제목 없음)'}</span>
                      </td>
                      <td style={tdStyle}>
                        {item.isDisplay !== false
                          ? <Badge theme="success">노출</Badge>
                          : <Badge theme="secondary">숨김</Badge>}
                      </td>
                      <td style={{...tdStyle, color: '#6B7280'}}>{item.createdAt ? moment(item.createdAt).format('YYYY-MM-DD') : ''}</td>
                      <td style={tdStyle}>
                        <Button size="sm" theme="light" onClick={() => this.openEdit(item)} style={{marginRight: 4}}>
                          <FeatherIcon icon="edit-2" size="12"/> 수정
                        </Button>
                        <Button size="sm" theme="danger" onClick={() => this.remove(item)}>
                          <FeatherIcon icon="trash-2" size="12"/> 삭제
                        </Button>
                      </td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              )}
              {this.renderPagination()}
            </div>
          </div>
        </div>

        {/* 작성/수정 모달 */}
        <Modal open={this.isModalOpen} toggle={() => {}} size="lg" className="bl-modal">
          <ModalHeader toggle={() => this.isModalOpen = false}>
            {this.editMode === 'create' ? '블로그 글 작성' : '블로그 글 수정'}
          </ModalHeader>
          <ModalBody style={{padding: '20px 24px', maxHeight: '80vh', overflowY: 'auto'}}>
            <div style={{marginBottom: 16}}>
              <label style={mLabel}>제목</label>
              <FormInput value={this.form.title} onChange={e => this.form.title = e.target.value} placeholder="블로그 글 제목"/>
            </div>
            <Row>
              <Col md="8">
                <div style={{marginBottom: 16}}>
                  <label style={mLabel}>URL 슬러그 <span style={{color:'#9CA3AF',fontWeight:400}}>(SEO · 주소에 사용)</span></label>
                  <div style={{display: 'flex', gap: 6}}>
                    <FormInput value={this.form.slug} onChange={e => this.form.slug = e.target.value} placeholder="비우면 제목으로 자동 생성"/>
                    <Button theme="light" onClick={() => this.form.slug = this.slugify(this.form.title)} style={{whiteSpace: 'nowrap'}}>자동생성</Button>
                  </div>
                </div>
              </Col>
              <Col md="4">
                <div style={{marginBottom: 16}}>
                  <label style={mLabel}>작성자 <span style={{color:'#9CA3AF',fontWeight:400}}>(SEO)</span></label>
                  <FormInput value={this.form.author} onChange={e => this.form.author = e.target.value} placeholder="예: 온리플"/>
                </div>
              </Col>
            </Row>
            <div style={{marginBottom: 16}}>
              <label style={mLabel}>메타 설명 <span style={{color:'#9CA3AF',fontWeight:400}}>(SEO · 검색결과/SNS 미리보기 요약, 권장 ~160자)</span></label>
              <FormTextarea rows="2" value={this.form.metaDescription} onChange={e => this.form.metaDescription = e.target.value} placeholder="비우면 요약(summary)을 사용합니다."/>
            </div>
            <div style={{marginBottom: 16}}>
              <label style={mLabel}>태그 <span style={{color:'#9CA3AF',fontWeight:400}}>(SEO · 쉼표로 구분)</span></label>
              <FormInput value={this.form.tags} onChange={e => this.form.tags = e.target.value} placeholder="예: 봄세일, 코디, 신상"/>
            </div>
            <Row>
              <Col md="8">
                <div style={{marginBottom: 16}}>
                  <label style={mLabel}>썸네일 이미지 URL</label>
                  <FormInput value={this.form.thumbnail} onChange={e => this.form.thumbnail = e.target.value} placeholder="https://... (선택)"/>
                </div>
              </Col>
              <Col md="4">
                <div style={{marginBottom: 16}}>
                  <label style={mLabel}>노출 여부</label>
                  <div style={{display: 'inline-flex', gap: 8}}>
                    <button type="button" onClick={() => this.form.isDisplay = true} style={segStyle(this.form.isDisplay === true)}>노출</button>
                    <button type="button" onClick={() => this.form.isDisplay = false} style={segStyle(this.form.isDisplay === false)}>숨김</button>
                  </div>
                </div>
              </Col>
            </Row>
            <div style={{marginBottom: 16}}>
              <label style={mLabel}>요약</label>
              <FormInput value={this.form.summary} onChange={e => this.form.summary = e.target.value} placeholder="목록/검색용 요약 (선택)"/>
            </div>
            <div style={{marginBottom: 4}}>
              <label style={mLabel}>내용</label>
              <ReactQuill
                value={this.form.content}
                onChange={(value) => this.form.content = value}
                modules={this.quillModules}
                formats={this.quillFormats}
                style={{background: '#fff'}}
              />
            </div>
          </ModalBody>
          <div style={{display: 'flex', justifyContent: 'flex-end', padding: '12px 24px', borderTop: '1px solid #E5E7EB', gap: 8}}>
            <Button theme="light" onClick={() => this.isModalOpen = false}>취소</Button>
            <Button theme="primary" onClick={this.save}>
              <FeatherIcon icon="save" size="14" style={{marginRight: 4}}/> 저장
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}

export default BlogList;
